import { useTranslations } from 'next-intl';
import Toast from '@/components/ui/Toast/toast';

/**
 * Error toast shown when a round verification can't be started or fails.
 */
export const useVerificationFailedToast = () => {
  const t = useTranslations('fair-play.verify-win');

  return () => Toast({
    type: 'error',
    title: t('verification-failed.title'),
    description: t('verification-failed.description'),
  });
};
